import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfoOverSm = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 100 100",
	style: { enableBackground: "new 0 0 100 100" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
		style: { fill: "#01BBD2" },
		d: "M50,89.8c-21.5,0-39-17.5-39-39s17.5-39,39-39s39,17.5,39,39S71.5,89.8,50,89.8z M50,15.8 c-19.3,0-35,15.7-35,35s15.7,35,35,35s35-15.7,35-35S69.3,15.8,50,15.8z"
	}) }), /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
		style: { fill: "#676C73" },
		d: "M40.8,68.6c0.2-0.7,0.4-1.7,0.8-3L46.1,49c0-0.2,0.1-0.4,0.1-0.6s0.1-0.4,0.1-0.5 c0-1-0.3-1.6-0.9-1.8c-0.6-0.2-1.8-0.4-3.4-0.5v-2c1.4-0.1,3.4-0.3,6.1-0.6c2.7-0.3,4.5-0.6,5.6-0.8l3.2-0.6L51,62.7 c-0.5,1.8-0.8,3.1-1,3.8c-0.4,1.8-0.7,2.9-0.7,3.5c0,0.5,0.1,0.9,0.4,1c0.2,0.2,0.5,0.2,0.8,0.2c0.7,0,1.7-0.6,2.8-1.9 c1.1-1.3,2.1-2.6,2.9-4l1.6,1.1c-2.4,3.6-4.3,5.9-5.6,7.2c-2.1,2-4.4,3-6.8,3c-1.4,0-2.6-0.4-3.6-1.3c-1.1-0.8-1.6-2.1-1.6-3.8 C40.3,70.9,40.5,69.9,40.8,68.6z M58.2,26.4c1,1,1.4,2.1,1.4,3.5s-0.5,2.6-1.4,3.5S56.1,35,54.7,35s-2.6-0.5-3.5-1.5 s-1.5-2.2-1.5-3.5s0.5-2.5,1.5-3.5c1-1,2.2-1.4,3.5-1.4S57.3,25.5,58.2,26.4z"
	}) }) })]
});
export default SvgInfoOverSm;
